import { render } from "../../templates/properties.html?vue&type=template&id=490346a3&scoped=true"
import script from "./properties.vue?vue&type=script&lang=js"
export * from "./properties.vue?vue&type=script&lang=js"

import "./properties.vue?vue&type=style&index=0&id=490346a3&scoped=true&lang=scss"
import "./properties.vue?vue&type=style&index=1&id=490346a3&lang=css"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490346a3"]])

export default __exports__